/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Ai_Notice_Learn_MoreInputs */

const en_candidate_ai_notice_learn_more = /** @type {(inputs: Candidate_Ai_Notice_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn more`)
};

const de_candidate_ai_notice_learn_more = /** @type {(inputs: Candidate_Ai_Notice_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr erfahren`)
};

const fr_candidate_ai_notice_learn_more = /** @type {(inputs: Candidate_Ai_Notice_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En savoir plus`)
};

const es_candidate_ai_notice_learn_more = /** @type {(inputs: Candidate_Ai_Notice_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más información`)
};

const it_candidate_ai_notice_learn_more = /** @type {(inputs: Candidate_Ai_Notice_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scopri di più`)
};

const nl_candidate_ai_notice_learn_more = /** @type {(inputs: Candidate_Ai_Notice_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meer informatie`)
};

const pl_candidate_ai_notice_learn_more = /** @type {(inputs: Candidate_Ai_Notice_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dowiedz się więcej`)
};

const fi_candidate_ai_notice_learn_more = /** @type {(inputs: Candidate_Ai_Notice_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lue lisää`)
};

const da_candidate_ai_notice_learn_more = /** @type {(inputs: Candidate_Ai_Notice_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Læs mere`)
};

const sv_candidate_ai_notice_learn_more = /** @type {(inputs: Candidate_Ai_Notice_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Läs mer`)
};

/**
* | output |
* | --- |
* | "Learn more" |
*
* @param {Candidate_Ai_Notice_Learn_MoreInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const candidate_ai_notice_learn_more = /** @type {((inputs?: Candidate_Ai_Notice_Learn_MoreInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Ai_Notice_Learn_MoreInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_ai_notice_learn_more(inputs)
	if (locale === "fr") return fr_candidate_ai_notice_learn_more(inputs)
	if (locale === "es") return es_candidate_ai_notice_learn_more(inputs)
	if (locale === "it") return it_candidate_ai_notice_learn_more(inputs)
	if (locale === "nl") return nl_candidate_ai_notice_learn_more(inputs)
	if (locale === "pl") return pl_candidate_ai_notice_learn_more(inputs)
	if (locale === "fi") return fi_candidate_ai_notice_learn_more(inputs)
	if (locale === "da") return da_candidate_ai_notice_learn_more(inputs)
	if (locale === "sv") return sv_candidate_ai_notice_learn_more(inputs)
	return en_candidate_ai_notice_learn_more(inputs)
});